import { ColumnDef, TableMeta } from '@tanstack/react-table';
import { get, merge } from 'lodash';
import { ObjectType, TableColumn, ColumnOverrides } from '..';
import { CellStrategy } from '../cellTypes';
import { getColumnDefWithPresets } from '.';

/**
 * This method constructs the column definitions for a table based on the table data
 * @param data table data
 * @param columnOverrides column info that will override defaults
 * @param tableOptions options for table
 * @returns an array of TanStack ColumnDef objects
 */
export const getColumnDefs = <TData>(
  data: TData[],
  columnOverrides?: ColumnOverrides<TData>,
  tableOptions?: Partial<TableMeta<TData>>,
): ColumnDef<TData>[] => {
  const cols = Object.keys(data[0] as ObjectType).map(key => ({ id: key } as TableColumn<TData>));

  // handle presets
  const colDefs = cols.map(col => {
    const columnOverride = get(columnOverrides, col.id);
    return getColumnDefWithPresets(col, data, columnOverride, tableOptions);
  });

  // merge with default TanStack column def
  return colDefs.map(col => merge({}, CellStrategy.getDefaultColumnDef(col), col));
};
